<template>
  <div class="rmk-page">
    <m-loading :loading="loading" />
    <div class="works">
      <img
        :src="img"
        alt=""
        :style="{ transform: `scale(${scale})` }"
        @click="viewImage(img)"
      />
      <!-- <div class="handle">
        <div @click="zoomChange(1)">
          <i class="el-icon-zoom-in"></i>
        </div>
        <div @click="zoomChange(0)">
          <i class="el-icon-zoom-out"></i>
        </div>
      </div> -->
    </div>
    <div class="rmk-lst">
      <div class="rmk-on" v-if="!isRemark || reRemark">
        <SignTitle title="点评/驳回" />
        <div class="inp">
          <textarea maxlength="500" v-model="content" placeholder="说点什么吧~">
          </textarea>
          <span>{{ count }}/500</span>
        </div>
        <div class="score">
          <div class="tit">打分（100分制）</div>
          <div class="field">
            <!-- <input type="number" v-model="nowScore" /> -->
            <!-- <el-input type="number" v-model="nowScore"></el-input> -->
            <van-field
              :max="100"
              :min="0"
              v-model="nowScore"
              type="digit"
              label="整数"
              @input="integerFormat($event)"
            />
            <div>分</div>
          </div>
        </div>
        <div class="tips">
          <p>打分参考：</p>
          <p>一等奖：打分&gt;90</p>
          <p>二等奖：80≤打分≤90</p>
          <p>三等奖：70≤打分&lt;80</p>
        </div>
        <div class="submit">
          <van-button
            @click="submitFn"
            color="linear-gradient(to right, #1ebf5f, #37dc8d)"
            >提交</van-button
          >
          <van-button @click="rejectFn" color="#616864">驳回</van-button>
        </div>
      </div>
      <div class="list">
        <SignTitle title="点评列表" />

        <div class="item" v-for="(rmk, i) in rmkLst" :key="i">
          <div class="head">
            <div class="inf">
              <img :src="rmk.head" alt="" />
              <div>{{ rmk.name }}</div>
              <span>{{ rmk.time }}</span>
            </div>
            <div
              class="edit"
              v-if="rmk.isMy && rmk.isUpd && !(!isRemark || reRemark)"
              @click="editConfirm"
            >
              修改
            </div>
          </div>
          <p class="content">{{ rmk.content }}</p>
          <div class="score-number">
            <span></span>
            <p>{{ rmk.score }}分</p>
            <span></span>
          </div>
        </div>
        <div class="none-com" v-if="rmkLst.length === 0">暂无评论</div>
      </div>
    </div>
  </div>
</template>

<script>
import SignTitle from "@/components/pub/SignTitle";
import {
  getWorksByJudges,
  commentWorks,
  lockCommentWorks,
  unlockCommentWorks
} from "@/utils/api/judge";
export default {
  components: {
    SignTitle
  },
  computed: {
    count() {
      return this.content.length;
    }
  },
  data() {
    return {
      // 作品列表
      id: null,
      // 是否点评
      isRemark: 0,
      //
      loading: false,
      // 是否能重新评论
      reRemark: false,
      // 评论内容
      content: "",
      // 分数
      nowScore: null,
      scale: 1,
      img: "",
      // 该作品的评论列表
      rmkLst: [],
      page: 1
    };
  },
  methods: {
    integerFormat(val) {
      if (parseInt(val) > 100) {
        this.nowScore = 100;
      }
      if (parseInt(val) < 0) {
        this.nowScore = 0;
      }
    },
    // 驳回
    rejectFn() {
      if (!this.content) {
        this.$toast.fail("驳回原因不能为空！");
        return;
      }
      if (this.content.length > 50) {
        this.$toast.fail("驳回原因不能超过50字！");
        return;
      }
      const p = {
        rejectReason: this.content,
        worksType: 1,
        worksId: this.id
      };
      this.$Dialog
        .confirm({
          message: "确认提交驳回？"
        })
        .then(() => {
          commentWorks(p).then((res) => {
            if (res.success) {
              this.$root.$toast.success({
                message: "驳回成功",
                duration: 2000,
                onClose: () => {
                  // this.getWorksDetail();
                  // let query = this.$route.query;
                  // query.isRemark = 1;
                  // let path = this.$route.path;
                  // this.$router.push({
                  //   path,
                  //   query
                  // });
                  this.$router.go(-1);
                }
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 提交评论
    submitFn() {
      if (!this.nowScore) {
        this.$toast.fail("分数不可为空");
        return;
      }
      const p = {
        comment: this.content,
        fraction: this.nowScore,
        worksId: this.id,
        worksType: 0
      };
      commentWorks(p).then((res) => {
        if (res.success) {
          this.$root.$toast.success({
            message: "评论成功",
            duration: 2000,
            onClose: () => {
              // this.getWorksDetail();
              // let query = this.$route.query;
              // query.isRemark = 1;
              // let path = this.$route.path;
              // this.$router.push({
              //   path,
              //   query
              // });
              this.$router.go(-1);
            }
          });
        }
      });
    },
    // 查看作品
    viewImage(img) {
      this.$root.$ImagePreview([img]);
    },
    zoomChange(type) {
      type ? (this.scale += 0.25) : (this.scale -= 0.25);
      if (this.scale < 0.25) {
        this.scale = 0.25;
      }
    },
    // 获得作品详情
    getWorksDetail() {
      const id = this.$route.query.id;
      this.loading = true;
      getWorksByJudges(id).then((res) => {
        if (res.success) {
          this.img = res.data.imgs;
          this.rmkLst = res.data.commentsWorksVoList.map((e) => {
            return {
              id: e.id,
              head: e.judgesImg,
              name: e.judgesName,
              time: e.addTime,
              score: e.fraction,
              content: e.comment,
              isMy: e.isMy,
              isUpd: e.isUpd
            };
          });
        }
        this.loading = false;
      });
    },
    // 评论修改确认
    editConfirm() {
      this.$Dialog
        .confirm({
          title: "是否修改点评",
          message: "7天内只可修改一次，后续若有修改请联系平台管理员申请",
          confirmButtonText: "是",
          confirmButtonColor: "#3478f7",
          cancelButtonText: "否",
          cancelButtonColor: "#fe1200"
        })
        .then(() => {
          // 显示评论框
          this.reRemark = true;
        })
        .catch(() => {
          // on cancel
        });
    },
    // 锁定作品，不让其他评委点评
    lockingWorks() {
      lockCommentWorks(this.id);
    },
    // 解锁作品
    unlockingWorks() {
      unlockCommentWorks(this.id);
    }
  },
  mounted() {
    this.id = parseInt(this.$route.query.id);
    this.isRemark = parseInt(this.$route.query.isRemark);
    this.getWorksDetail();
    this.lockingWorks();
  },
  destroyed() {
    // 如果非正常退出，后台自锁定起，十分钟后解锁
    this.unlockingWorks();
  }
};
</script>
<style lang="scss" scoped>
.rmk-page {
  width: 100%;
  height: 100%;
  max-width: 10rem;
  overflow-y: scroll;
  .works {
    height: 50vh;
    background-color: #333333;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    // padding: 10px 20px;
    img {
      max-width: 100%;
      max-height: 100%;
      transition: transform 0.3s;
    }
    .handle {
      position: absolute;
      height: 32px;
      width: 100%;
      left: 0;
      bottom: 80px;
      padding: 0 45px;
      display: flex;
      justify-content: space-between;
      div {
        border-radius: 16px;
        height: 32px;
        width: 32px;
        background-color: #fff6;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          font-size: 14px;
          font-weight: 700;
          color: #fff;
        }
      }
    }
  }
  .rmk-lst {
    padding: 0 20px;
    .rmk-on {
      .inp {
        border-radius: 10px;
        background-color: #f9f9f9;
        padding: 20px;
        height: 111px;
        position: relative;
        textarea {
          border: none;
          background: unset;
          font-size: 12px;
          color: #000;
          width: 100%;
          height: 100%;
          &:-ms-input-placeholder {
            color: #999;
          }
          &::placeholder {
            color: #999;
          }
        }
        span {
          position: absolute;
          right: 15px;
          bottom: 5px;
          color: #666;
          font-size: 12px;
        }
      }
      .score {
        display: flex;
        height: 50px;
        align-items: center;
        justify-content: space-between;
        .tit {
          display: flex;
          &::before {
            content: "*";
            color: red;
            display: block;
            position: relative;
          }
          font-size: 13px;
          color: #333;
        }
        .field {
          width: 95px;
          height: 30px;
          border-radius: 5px;
          border: 1px solid #f2f2f2;
          display: flex;
          input,
          .el-input {
            border: none;
            background: unset;
            height: 100%;
            width: 65px;
            font-size: 12px;
            padding: 0 5px;
            input {
              height: 100%;
              width: 100%;
              padding: 0;
            }
          }
          & > div:not(.van-cell) {
            width: 30px;
            background-color: #f2f2f2;
            font-size: 13px;
            text-align: center;
            line-height: 30px;
          }
        }
      }
      .tips {
        padding: 15px;
        line-height: 16px;
        font-size: 12px;
        color: #cccccc;
        text-align: left;
        p {
        }
      }
      .submit {
        margin: 0 auto;
        margin-top: 16px;
        display: flex;
        justify-content: space-around;
        .van-button {
          width: 140px;
          border-radius: 8px;
        }
      }
    }
    .list {
      padding: 20px 0;
      text-align: left;
      .item {
        // height: 178px;
        padding: 15px 0;
        border-bottom: 1px solid #f2f2f2;
        width: 100%;
        .head {
          display: flex;
          height: 36px;
          width: 100%;
          justify-content: space-between;
          align-items: center;
          .inf {
            display: flex;
            align-items: center;
            width: 100%;
            img {
              height: 36px;
              width: 36px;
              border-radius: 18px;
            }
            div {
              margin-left: 10px;
              font-size: 14px;
              color: #666666;
              max-width: 40%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            span {
              margin-left: 5px;
              font-size: 12px;
              color: #999999;
              margin-top: 5px;
            }
          }
          .edit {
            width: 45px;
            height: 20px;
            background-image: linear-gradient(to right, #1ebf5f, #37dc8d);
            justify-content: center;
            align-items: center;
            color: #fff;
            display: flex;
            border-radius: 5px;
            font-size: 12px;
          }
        }
        .content {
          line-height: 24px;
          font-size: 12px;
          color: #666;
          padding-left: 45px;
          text-align: justify;
          white-space: normal;
          max-width: 100%;
          word-wrap: break-word;
        }
        .score-number {
          height: 30px;
          padding: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 10px;
          p {
            color: #16d77a;
            font-size: 16px;
            margin: 0 5px;
          }
          span {
            display: block;
            height: 1px;
            width: 36px;
            background-color: #16d77a;
          }
        }
      }
      .none-com {
        height: 100px;
        width: 100%;
        font-size: 12px;
        color: #999;
        justify-content: center;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
<style lang="scss">
.rmk-page {
  .rmk-lst {
    .score {
      .field {
        .el-input {
          input {
            height: 100%;
            width: 100%;
            padding: 0;
            border: none;
          }
        }
        .van-field {
          border: none;
          background: unset;
          height: 100%;
          width: 65px;
          font-size: 12px;
          padding: 0 5px;
          .van-field__label {
            display: none;
          }
          .van-field__value {
            line-height: 30px;
          }
        }
      }
    }
  }
}
</style>
